import { Push, AppPushServiceSubscriptionParams } from '@/models/appPushes.model';
import { ApiService } from '../../services/backend-api/api.services';
import swal from '../../helper/swal.helper';

export class AppPushRepository {
  private apiService: ApiService = new ApiService();

  async fetchSubscriptionList(params: AppPushServiceSubscriptionParams): Promise<{items: Push[]}> {
    try {
      const response = await this.apiService.get('/v1/usin-subscription-event', params);
      return { items: response.data };
    } catch (error) {
      swal.alert('app-push fetching Error');
      throw error;
    }
  }
}